require('./scrollSmooth');
window.axios = require('axios');
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
